import { render, staticRenderFns } from "./bulk-resolve-duplicate-link.vue?vue&type=template&id=493211c0&scoped=true"
import script from "./bulk-resolve-duplicate-link.vue?vue&type=script&lang=js"
export * from "./bulk-resolve-duplicate-link.vue?vue&type=script&lang=js"
import style0 from "./bulk-resolve-duplicate-link.vue?vue&type=style&index=0&id=493211c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493211c0",
  null
  
)

export default component.exports